import cfg, {handleResponse, handlePrepareData, handlePrepareDataItem} from "../constants";
import {authMiddleware} from "./loginAction";

export const deleteFaqCategoryAction = (categoryId) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/faq/categories/' + categoryId, {
    method: "DELETE",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const updateFaqCategoryAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/faq/categories' + (body.id ? '/' + body.id : ''), {
    method: body.id ? "PUT" : "POST",
    headers: headers,
    body: JSON.stringify(body)
  }).then(handleResponse).then(handlePrepareData);
};

export const getFaqCategoriesAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/faq/categories', {
    method: "GET",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const getFaqAction = ({category_id, page, limit, search}, signal) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  const params = new URLSearchParams({ page, limit, search }).toString();
  return fetch(cfg.base_url + '/auth/faq/items' + (category_id ? '/' + category_id : '') + '?' + params, {
    method: "GET",
    headers,
    signal
  }).then(handleResponse).then(handlePrepareData);
};

export const deleteFaqAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/faq/items/' + id, {
    method: "DELETE",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const updateFaqAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/faq/items' + (body.id ? '/' + body.id : ''), {
    method: body.id ? "PUT" : "POST",
    headers: headers,
    body: JSON.stringify(body)
  }).then(handleResponse).then(handlePrepareData);
};

export const getFaqSettingsAction = ({page, limit, search}, signal) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  const params = new URLSearchParams({ page, limit, search }).toString();
  return fetch(cfg.base_url + '/auth/faq/settings?' + params, {
    method: "GET",
    headers,
    signal
  }).then(handleResponse).then(handlePrepareData);
};

export const getFaqSettingsItemAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/faq/settings/' + id, {
    method: "GET",
    headers
  }).then(handleResponse).then(handlePrepareDataItem);
};

export const deleteFaqSettingsAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/faq/settings/' + id, {
    method: "DELETE",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const updateFaqSettingsAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/faq/settings' + (body.id ? '/' + body.id : ''), {
    method: body.id ? "PUT" : "POST",
    headers: headers,
    body: JSON.stringify(body)
  }).then(handleResponse).then(handlePrepareData);
};